const routes = [
  {
    path: 'planning',
    component: () => import(/* webpackChunkName: "sales-index" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'planning',
        component: () => import(/* webpackChunkName: "sales-home" */ './views/Home.vue'),
      },
      {
        path: 'create-new',
        name: 'create-new',
        component: () => import(/* webpackChunkName: "create-new" */ './views/CreateNew.vue'),
      },
    ],
  },
];

export default routes;
